export default __webpack_public_path__ + "static/media/hcinfo.54eeba22.png";